class LocalCart { 
  constructor(storageKey = "localCart") {  
      this.storageKey = storageKey, this.cart = this._loadCart();
      this.welcome25 = updateWelcome25Row();
      // returns cents discount
  }
  _loadCart() {
      try { 
          const stored = localStorage.getItem(this.storageKey),
              parsed = stored ? JSON.parse(stored) : {};
          return {
              items: Array.isArray(parsed.items) ? parsed.items : [],
              attributes: Array.isArray(parsed.attributes) ? parsed.attributes : [],
              total_qty: parsed.total_qty || 0,
              item_count: parsed.item_count || 0,
              total_price: parsed.total_price || 0,
              original_total_price: parsed.total_price || 0,
              original_keto_total_price: parsed.original_keto_total_price || 0
          } 
      } catch {
          return {
              items: [],
              total_qty: 0,
              item_count: 0,
              total_price: 0,
              original_total_price: 0,
              original_keto_total_price: 0,
              attributes: []
          }
      }
  }
  _saveCart() {
    
    this.cart.total_qty = this.cart.items.reduce((sum, item) => sum + item.qty, 0);
    this.cart.item_count = this.cart.items.reduce((sum, item) => sum + item.qty, 0);

    this.cart.total_price = this.cart.items.reduce((sum, item) => {
        if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")){          
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.keto_price;
          }
          return sum + item.qty * item.price;
        }else{
          return sum + item.qty * item.price;
        }
    }, 0);   

    this.cart.original_total_price = this.cart.items.reduce((sum, item) => {
        if(userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers")){
          if(item.product_type == "LUNCH & DINNER"){
            return sum + item.qty * item.keto_price;
          }
          return sum + item.qty * item.price;
        }else{
          return sum + item.qty * item.price;
        }
    }, 0);

    this.cart.original_keto_total_price = this.cart.items.reduce((sum, item) => {
          return sum + item.qty * item.keto_price;
    }, 0);

    localStorage.setItem(this.storageKey, JSON.stringify(this.cart));
  }

  overwriteFromRemoteCart() {
    return fetch("/cart.json")
      .then(res => res.json())
      .then(data => {
        const cartLevelFrequency =
        (data?.attributes?.orderType && typeof data.attributes.orderType === "string")
          ? data.attributes.orderType
          : (data?.attributes?.orderType?.type || null);

        if (!Array.isArray(data.items) || data.items.length === 0 || !data.items[0].id) {
          this.cart = {
            items: [],
            total_qty: 0,
            item_count: 0,
            total_price: 0,
            original_total_price: 0,
            original_keto_total_price: 0,
            attributes: []
          };
        } else {
          const items = data.items.map(src => {
            // per-item selectedFrequency (preferred), else cart-level
            const itemProps = src.properties || {};
            const itemFrequency = itemProps.selectedFrequency || cartLevelFrequency || null;

            // choose selling plan by frequency
            let sellingPlan = null;
            if (itemFrequency === "WeeklySubscription") {
              sellingPlan = SELLING_PLAN_S;
            } else if (itemFrequency === "FortnightlySubscription") {
              sellingPlan = SELLING_PLAN_FS;
            }

            // ensure properties has selectedFrequency if we’re on a subscription
            const properties = {
              ...itemProps
              //...(itemFrequency ? { selectedFrequency: itemFrequency } : {})
            };

            return {
              product_id: src.product_id,
              variant_id: src.variant_id,
              title: src.title,
              url: src.url,
              image: src.image,
              price: src.original_price,     // cents
              keto_price: 1050,              // your fixed keto cents
              qty: src.quantity,
              product_type: src.product_type,
              selling_plan: sellingPlan,
              bf_true: src.bf_true,
              properties
            };
          });

          //console.log(items);

          this.cart = {
            items,
            total_qty: data.items.reduce((sum, item) => sum + item.quantity, 0),
            item_count: data.item_count,
            total_price: data.total_price,
            original_total_price: data.original_total_price,
            original_keto_total_price: data.total_price,
            attributes: data.attributes || []
          };
        }
  
        this._saveCart(); // Save to localStorage
        return this.cart;
      })
      .catch(error => {
        console.error("Error overriding cart from remote:", error);
      });
  }
  
  customaddToCart(variantId, quantity, selling_plan=null) {
    var formData = {
      'items': [{
        'id': variantId,
        'quantity': quantity,
        'selling_plan': selling_plan
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cartData => { // Renamed to cartData to avoid conflicts
        // console.log('Success:', cartData);
        getCartData()
          .then(data => {
            this.updateCartInfoFromLocal('.cart-item-loop');
          })
          .catch(error => {
            console.error('Error getting cart data:', error);
          });
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }

  addItem(productId, variantId, title, url, image, price, qty, product_type, selling_plan = null, $productQuantityAction = null, bf_true) {    
    let index;
    const ketoPrice = 1050;
    
    //alert(bf_true);

    let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
    let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

    if(!(deliveryInfoNew.deliveryDate && deliveryInfoNew.deliveryEnd && state_data.address && state_data.phone && state_data.freq && state_data.suburb && state_data.state && state_data.postcode)){

      document.querySelector('.cart-count')?.click();

    }else if(!((deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryEnd != '') && (state_data.address != '') && (state_data.phone != '') && (state_data.freq != '') && (state_data.suburb != '') && (state_data.state != '') && (state_data.postcode != ''))){

      document.querySelector('.cart-count')?.click();

    }

    selling_plan ? index = this.cart.items.findIndex(item => item.variant_id === variantId && item.selling_plan === selling_plan) : index = this.cart.items.findIndex(item => item.variant_id === variantId), index !== -1 ? (this.cart.items[index].qty += qty, this.cart.items[index].qty <= 0 && this.cart.items.splice(index, 1)) : this.cart.items.push({
        product_id: productId,
        variant_id: variantId,
        title,
        url,
        image,
        price,
        keto_price: ketoPrice,
        qty,
        product_type,
        selling_plan,
        bf_true
    }), this._saveCart();
    this.updateCartInfoFromLocal('.cart-item-loop');   
  }

  addItemCondition(productId, variantId, title, url, image, price, qty, product_type, selling_plan = null, $productQuantityAction = null, produc_postcol = null, acknowledge_message = null, bf_true) {    
    
    let index;
    const ketoPrice = KETO_PRICE;
    const validAddress = localStorage.getItem("widgetAddress");
    /*if((!validAddress || validAddress === "null" || validAddress === "undefined" || validAddress.trim() === "") && (produc_postcol=='True' || produc_postcol=='true') && (acknowledge_message=='')) {      
      
      // Set hidden inputs with product data
      $('#modalVariantId').val(variantId);
      $('#modalQuantity').val(qty);
      $('#productTitle').text(title);
      $('#modalSellingPlan').val(selling_plan);
      $('#modalTitle').val(title);
      $('#modalProductId').val(productId);
      $('#modalUrl').val(url);
      $('#modalImage').val(image);
      $('#modalPrice').val(price);
      $('#modalQty').val(qty);
      $('#modalProductType').val(product_type);
        
      $('.customPopupModal').modal('show');
      $('.first_section').show();
      $('.second_section').hide();

    }else if(acknowledge_message=='True' || acknowledge_message=='true'){

      $('#customAKModal')
        .data('variant-id', variantId)
        .data('qty', qty)
        .data('selling-plan', selling_plan)
        .data('title', title)
        .data('product-id', productId)
        .data('url', url)
        .data('image', image)
        .data('price', price)
        .data('product-type', product_type)
        .modal('show');      
    
    } else {
      
      if(produc_postcol=='True' || produc_postcol=='true'){
          
          const addressResponse = JSON.parse(validAddress);
          if (addressResponse.postcode && (addressResponse.postcode.startsWith('5') || addressResponse.postcode.startsWith('6'))) {

                $('.search_postcode').val(addressResponse.postcode);
                $('#modalVariantId').val(variantId);
                $('#modalQuantity').val(qty);
                $('#productTitle').text(title);
                $('#modalSellingPlan').val(selling_plan);
                $('#modalTitle').val(title);
                $('#modalProductId').val(productId);
                $('#modalUrl').val(url);
                $('#modalImage').val(image);
                $('#modalPrice').val(price);
                $('#modalQty').val(qty);
                $('#modalProductType').val(product_type);
                $('.customPopupModal').modal('show');       
                $('.first_section').show();
                $('.second_section').hide();
                $('#showMessage').text('This product is not available in your location.');
          }else{
          
            addressConfirmPostCode(addressResponse.postcode, addressResponse.locality_name).then((response) => {
             if(response=='Success'){
               
               this.addItem(productId, variantId, title, url, image, price, qty, product_type, selling_plan);
               
             }else{   
               
                $('#modalVariantId').val(variantId);
                $('#modalQuantity').val(qty);
                $('#productTitle').text(title);
                $('#modalSellingPlan').val(selling_plan);
                $('#modalTitle').val(title);
                $('#modalProductId').val(productId);
                $('#modalUrl').val(url);
                $('#modalImage').val(image);
                $('#modalPrice').val(price);
                $('#modalQty').val(qty);
                $('#modalProductType').val(product_type);
               
                $('.customPopupModal').modal('show'); 
                if(addressResponse.postcode){
                  $('.first_section').hide();
                  $('.second_section').show();
                  $('#showMessageAddres').text('Delivery to your area is currently unavailable. Please contact us for assistance.');
                }
             }
          });                  
          } 

      }else{
        this.addItem(productId, variantId, title, url, image, price, qty, product_type, selling_plan);
      }    
    }*/
    this.addItem(productId, variantId, title, url, image, price, qty, product_type, selling_plan, null, bf_true);
  }

  updateItem(productId, variantId, title, url, image, price, qty, product_type, selling_plan = null, $productQuantityAction = null) {
      let index;
      let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
      let state_data = JSON.parse(localStorage.getItem("window_state")   || "{}");

      if(!(deliveryInfoNew.deliveryDate && deliveryInfoNew.deliveryEnd && state_data.address && state_data.phone && state_data.freq && state_data.suburb && state_data.state && state_data.postcode)){

        document.querySelector('.cart-count')?.click();

      }else if(!((deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryEnd != '') && (state_data.address != '') && (state_data.phone != '') && (state_data.freq != '') && (state_data.suburb != '') && (state_data.state != '') && (state_data.postcode != ''))){

        document.querySelector('.cart-count')?.click();
        
      }
      selling_plan ? index = this.cart.items.findIndex(item => item.variant_id === variantId && item.selling_plan === selling_plan) : index = this.cart.items.findIndex(item => item.variant_id === variantId), index !== -1 && (this.cart.items[index].qty = qty, this.cart.items[index].qty <= 0 && this.cart.items.splice(index, 1)), this._saveCart(), $productQuantityAction?.removeClass("loading")
  }
  changeInToLocalCart(variantId, qty, $productQuantityAction = null) {
      $productQuantityAction && $productQuantityAction?.addClass("loading"), this.updateItem(null, variantId, null, null, null, null, qty, null, null, $productQuantityAction)
      localCart.updateCartInfoFromLocal(".cart-item-loop")
  }
  clearCartDataLocal() {
      this.cart = {
          items: [],
          total_qty: 0,
          item_count: 0,
          total_price: 0,
          original_total_price: 0,
          original_keto_total_price: 0
      }, localStorage.removeItem(this.storageKey);
      this.updateCartInfoFromLocal(".cart-item-loop");
      clearCartData();
  }
  countLunchAndDinnerMeals(items = this.cart.items) {
      return Array.isArray(items) ? items.reduce((total_count, item) => item.product_type === "LUNCH & DINNER" ? total_count + (parseInt(item.qty || item.quantity, 10) || 0) : total_count, 0) : 0
  }
  validatedAddress() {
      const validAddress = localStorage.getItem("widgetAddress");
      if (validAddress !== null) {
          const addressResponse = JSON.parse(validAddress),
              {
                  address_line_combined,
                  locality_name,
                  state_territory,
                  postcode
              } = addressResponse;
          return Object.fromEntries(Object.entries({
              "checkout[shipping_address][country]": "AU",
              "checkout[shipping_address][address1]": address_line_combined,
              "checkout[shipping_address][city]": locality_name,
              "checkout[shipping_address][province]": state_territory,
              "checkout[shipping_address][zip]": postcode
          }).filter(([_, value]) => value))
      }
      return !1
  }
  getCartData() {
      return {
          items: this.cart.items.map(item => ({
              id: item.variant_id,
              product_id: item.product_id,
              variant_id: item.variant_id,
              title: item.title,
              image: item.image,
              price: item.price,
              keto_price: 1050,
              quantity: item.qty,
              selling_plan: item.selling_plan || null,              
              bf_true: item.bf_true,
              url: item.url || "#",
              properties: item.properties || {},
              product_type: item.product_type || ""
          })),
          original_total_price: this.cart.original_total_price || 0,
          original_keto_total_price: this.cart.original_keto_total_price || 0,
          total_price: this.cart.total_price,
          total_count: this.cart.total_qty,
          item_count: this.cart.item_count,
          attributes: JSON.parse(localStorage.getItem("cartAttributes") || "{}")
      }
  }    
  
  formatWithDelimiters(cents, precision = 2, thousands = ',', decimal = '.') { 
    if (cents == null || isNaN(cents)) return (0).toFixed(precision);

    // Convert "cents" to dollars
    const negative = Number(cents) < 0;
    const absoluteCents = Math.abs(Number(cents));
    const amount = (absoluteCents / 100).toFixed(precision);

    const [intPart, decPart = ''] = amount.split('.');
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (negative ? '-' : '') + withThousands + (precision ? decimal + decPart : '');
    
  }

  formatMoney(cents, format = "$") {
    // Accept strings like "1,195", "1195", "1195.00", "-1195"
    if (typeof cents === 'string') {
      // keep digits and optional leading minus
      const cleaned = cents.replace(/(?!^-)[^\d]/g, '');
      cents = Number(cleaned);
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    let formatString = format || "$";
    const match = placeholderRegex.exec(formatString);

    // Determine the token (e.g., "amount", "amount_with_comma_separator")
    // and whether the caller passed a full template ("$")
    // or just the token ("amount").
    const hasBraces = !!match;
    const token = hasBraces
      ? match[1]
      : (/^\w+$/.test(formatString) ? formatString : "amount");

    // Compute the formatted value based on the token
    let value;
    switch (token) {
      case 'amount':
        value = this.formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = this.formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = this.formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = this.formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = this.formatWithDelimiters(cents, 2);
    }

    // If the caller gave a template with , replace it.
    // If they passed only the token, return just the value.
    return hasBraces ? '$'+formatString.replace(placeholderRegex, value) : '$'+value;
  }


  updateCartInfoFromLocal(cartCellId, reload = 0) {
    //this.formatMoney(1195); 
    const cart = this.getCartData();
    const cartCell = jQuery(cartCellId);
    jQuery(".upsell-desk-custom, .upsell-mob-custom").removeClass("display-none");
    jQuery(".main-cart-container").removeClass("w-100");
    if (typeof cartCellId !== "string" || !cartCell.length) {
      console.error("Invalid cartCellId provided or not found");
      return;
    }
      const { attributes = {}, items, total_price, item_count } = cart;
      const orderType = attributes?.orderType?.type ?? "WeeklySubscription";
  
      cartCell.empty();
  
      const total_count = item_count;
      const mealsCount = this.countLunchAndDinnerMeals(items);
      const cart_show_count = item_count;
  
      let totalPrice = 0;
  
      if (items.length > 0) {
        jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").show();
        jQuery(".cart-tempty-title").hide();
  
        items.forEach(item => {
          const { price, quantity, url, image, title, variant_id, product_type, id = variant_id, selling_plan = null, bf_true = false } = item;
          
          let priceHTML = "", comparePriceHTML = "";                    
          let actualPrice = price;
  
          if (orderType === "OneTimePurchase") { 

            let discount = 0;
            mealsCount >= oneTimeOffers.promo3.mealRange.max ? discount = oneTimeOffers.promo3.discounts :
            mealsCount >= oneTimeOffers.promo2.mealRange.max ? discount = oneTimeOffers.promo2.discounts :
            mealsCount >= oneTimeOffers.promo1.mealRange.max && (discount = oneTimeOffers.promo1.discounts);            
  
            let actualPrice2 = price;            

            if(((bf_true != 0) && bf_true) && !userLoggedIn){
              actualPrice2 = actualPrice2 - 200;
            }

            //console.log('actualPrice2', actualPrice2);
  
            if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
              const discountCents = Math.floor(actualPrice2 * customerData.ndisDiscountPercentage / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
  
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = 1050;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T1") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = 1120;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T2") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = 1080;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("T3") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const discountedPriceCents = 1050;
                totalPrice += discountedPriceCents * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }
            } else if (product_type === "LUNCH & DINNER" && discount > 0) {
              const discountCents = Math.floor(actualPrice2 * discount / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
  
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else {
              
              if(((bf_true != 0) && bf_true) && !userLoggedIn){
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice2)}</span>`;
              }else{                
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }

            }
          }
  
          if (orderType === "WeeklySubscription" || orderType === "FortnightlySubscription") {
            let actualPrice2 = price;              

            if(((bf_true != 0) && bf_true) && !userLoggedIn){
              actualPrice2 = actualPrice2 - 200;
            }

            //console.log('actualPrice2', actualPrice2);
  
            if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
              const discountCents = Math.floor(actualPrice2 * customerData.ndisDiscountPercentage / 100);
              const discountedPriceCents = actualPrice2 - discountCents;
  
              totalPrice += discountedPriceCents * quantity / 100;
              comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(discountedPriceCents)}</span>`;
            } else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
              if (product_type === "LUNCH & DINNER") {
                const subscriptionPrice2 = 1050;
                totalPrice += subscriptionPrice2 * quantity / 100;
                priceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(subscriptionPrice2)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              } else {
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="price-cart fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }
            } else {
              if(((bf_true != 0) && bf_true) && !userLoggedIn){
                totalPrice += actualPrice2 * quantity / 100;
                priceHTML = `<span class="fw-bold fs-16">${this.formatMoney(actualPrice2)}</span>`;
                comparePriceHTML = `<span class="compare-price-cart text-decoration-line-through fs-13">${this.formatMoney(actualPrice)}</span>`;
              }else{
                totalPrice += actualPrice2 * quantity / 100;
                comparePriceHTML = `<span class="fw-bold fs-16">${this.formatMoney(actualPrice)}</span>`;
              }
            }
          }
  
          const listItem = `
            <li class="cart-item d-flex">
              <div class="cart-image position-relative w-15 border rounded">
                <a href="${url}">
                  <img src="${image}" alt="${title}" class="img-fluid">
                </a>
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-orange px-2 py-1">${quantity}</span>
              </div>
              <div class="cart-title d-flex flex-column w-80">                
                <div class="delete-item-cart">
                  <a class="remove_from_cart" href="javascript:void(0);" onclick="localCart.changeInToLocalCart(${variant_id}, 0)">
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <a class="cart_item_title" href="${url}">${title.substring(0, 50)}</a>
                <div class="cart-pro-info d-flex align-items-center justify-content-between">
                  <div class="cart-qty-price">
                    <span class="quantity-${id} d-none">${quantity}</span>
                    <span class="price-box">
                      ${comparePriceHTML}
                      ${priceHTML}
                    </span>
                  </div>
                  <div class="product-quantity-action gap-3">
                    <div class="product-quantity" data-variant="${id}">
                      <div class="cart-plus-minus">
                        <div class="dec qtybutton" data-action="-"><i class="icon-minus fw-bolder"></i></div>
                        <input value="${quantity}" type="text" class="qtyinputcs" name="quantity" min="1" pattern="[0-9]*">
                        <span class="cusqtyspan quantity-${id}">${quantity}</span>
                        <div class="inc qtybutton" data-action="+"><i class="icon-plus fw-bolder"></i></div>
                      </div>
                    </div>
                    <span class="cart-loading load-anim"><i class="ion-load-a"></i></span>
                  </div>
                </div>
              </div>
            </li>
          `;
          cartCell.append(listItem);
        });
      } else {
        jQuery(".cart-item-loop, .cart-item-title, .subtotal-title-area").hide();
        jQuery(".cart-tempty-title").show();   
        jQuery(".cart-item-title").hide();
        jQuery(function() {
          //jQuery(".upsell-desk-custom, .upsell-mob-custom").addClass("display-none");
          //jQuery(".main-cart-container").addClass("w-100");
        });
      }

      if(window.innerWidth < 999){
        jQuery(".upsell-desk-custom, .upsell-mob-custom").addClass("display-none");
      }
  
      document.querySelectorAll(".total-discount-amount").forEach(el => el.textContent = "");
      const cartCounter = jQuery(".bigcounter");
      const cartcountitem = jQuery(".cart-count-item");      
  
      //if (!(subscriptionContractId && userLoggedIn)) {
        cartCounter.html(cart_show_count).addClass("added-cart-event");
        cartcountitem.html(cart_show_count);
      //}
  
      setTimeout(() => cartCounter.removeClass("added-cart-event"), 2000);
      jQuery(".currency .active").trigger("click");

      //console.log('totalPrice',totalPrice);  
  
      this.generateOfferDOM(cart, totalPrice);
      let state_data = JSON.parse(localStorage.getItem("window_state") || "{}");
      let url = new URL(window.location.href);
      let hasFlag = url.searchParams.has("open-mini-cart");
      let deliveryInfoNew = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");

      document.getElementById("finalflow").style.display = "none";
      document.getElementById("border-topbg-white").style.display = "block";
      document.getElementById("cart-item-wrap").style.display = "block";
      document.getElementById("cart-item-title").style.display = "block";

      //console.log(isLogin);

      /*if(state_data.freq == ''){
        state_data.freq = 'OneTimePurchase';
      }*/


      if(!reload && !((deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryEnd != '') && (state_data.address != '') && (state_data.phone != '') && (state_data.freq != '') && (state_data.suburb != '') && (state_data.state != '') && (state_data.postcode != ''))){
        
        console.log('phase','1');
        document.getElementById("border-topbg-white").style.display = "none";
        document.getElementById("cart-item-wrap").style.display = "none";
        document.getElementById("cart-item-title").style.display = "none";
        document.getElementById("finalflow").style.display = "block"; 

      }else if(!isLogin && !state_data.phone){
        
        console.log('2');
        document.getElementById("border-topbg-white").style.display = "none";
        document.getElementById("cart-item-wrap").style.display = "none";
        document.getElementById("cart-item-title").style.display = "none";
        document.getElementById("finalflow").style.display = "block"; 

      }else if(!isLogin && !reload){

        console.log('phase','3');

        if((deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryEnd != '') && state.address && state.phone && state.freq && state.suburb && state.state && state.postcode){
          
          console.log('phase','31');
          document.getElementById("finalflow").style.display = "none";
          document.getElementById("border-topbg-white").style.display = "block";
          document.getElementById("cart-item-wrap").style.display = "block";
          document.getElementById("cart-item-title").style.display = "block";

        }else{

          console.log('phase','32');
          document.getElementById("border-topbg-white").style.display = "none";
          document.getElementById("cart-item-wrap").style.display = "none";
          document.getElementById("cart-item-title").style.display = "none";
          document.getElementById("finalflow").style.display = "block"; 

        }

      }else if(!isLogin && reload){

        console.log('phase','4');
        document.getElementById("finalflow").style.display = "none";
        document.getElementById("border-topbg-white").style.display = "block";
        document.getElementById("cart-item-wrap").style.display = "block";
        document.getElementById("cart-item-title").style.display = "block";

      }else if(isLogin && reload){

        console.log('phase','5');
        document.getElementById("finalflow").style.display = "none";
        document.getElementById("border-topbg-white").style.display = "block";
        document.getElementById("cart-item-wrap").style.display = "block";
        document.getElementById("cart-item-title").style.display = "block";

      }else if(isLogin && !reload){

        console.log('phase','6');

        if((deliveryInfoNew.deliveryDate != '') && (deliveryInfoNew.deliveryEnd != '') && state.address && state_data.phone && state_data.freq && state_data.suburb && state_data.state && state_data.postcode){
          
          console.log('phase','61');
          document.getElementById("finalflow").style.display = "none";
          document.getElementById("border-topbg-white").style.display = "block";
          document.getElementById("cart-item-wrap").style.display = "block";
          document.getElementById("cart-item-title").style.display = "block";

        }else{

          console.log('phase','62');
          document.getElementById("border-topbg-white").style.display = "none";
          document.getElementById("cart-item-wrap").style.display = "none";
          document.getElementById("cart-item-title").style.display = "none";
          document.getElementById("finalflow").style.display = "block"; 

        }
      }

      /*console.log('reload', reload);
      console.log('state_data.date', state_data.date);
      console.log('state_data.phone', state_data.phone);
      console.log('state_data.address', state_data.address);
      console.log('state_data.freq', state_data.freq);
      console.log('state_data.suburb', state_data.suburb);
      console.log('state_data.state', state_data.state);
      console.log('state_data.postcode', state_data.postcode);*/

      if(hasFlag){

        document.querySelector('.cart-count')?.click();
        url.searchParams.delete("open-mini-cart");

        window.history.replaceState({}, document.title, url.toString());

        if(!reload && !((deliveryInfoNew.deliveryDate != '') && state.address && state.phone && state.freq && state.suburb && state.state && state.postcode)){
            document.getElementById("border-topbg-white").style.display = "none";
            document.getElementById("cart-item-wrap").style.display = "none";
            document.getElementById("cart-item-title").style.display = "none";
            document.getElementById("finalflow").style.display = "block"; 
            if(isLogin){
              //document.querySelector("#continueStart").disabled = ((document.querySelector("#address_11").value != '') ? false: true);
              //document.querySelector("#toDeliveryFromContact").disabled = ((document.querySelector("#address_12").value != '') ? false: true);
            }
        }
        
        if(!deliveryInfoNew.deliveryDate && state.phone){
          document.getElementById("step1").classList.add('hidden');
          //document.getElementById("step2_address").classList.remove('hidden');
        }
      }
  }
  
  getPromoForMeals(mealCount) {
    let matchedPromo = !1;
    for (const [promoName, offer] of Object.entries(promotionalOffers)) {
      const { min, max } = offer.mealRange;
      // Check if mealCount falls within the promo range (inclusive of min, exclusive of max)
      if (mealCount >= min && mealCount < max) {
        matchedPromo = promoName;
      }
    }
    return matchedPromo;
  }

  createFormData(deliveryInfo, isSubscription) {
      const cartData = this.getCartData(),
          filteredCart = cartData.items.map(item => ({
              id: item.variant_id,
              properties: item.properties,
              quantity: item.quantity
          }));
      
      let { attributes = {}, items, total_price, item_count } = cartData;
      let order_type = attributes?.orderType?.type ?? "WeeklySubscription";   

      let applicableOffer = !1;
      if (!(userLoggedIn && customerData?.tags?.includes("NDIS") && typeof customerData.ndisDiscountPercentage == "number")) {
          const responseMeals = this.countLunchAndDinnerMeals(cartData.items);
          applicableOffer = this.getPromoForMeals(responseMeals);
          //console.log('responseMeals', responseMeals); 
          //console.log('applicableOffer1', applicableOffer);   
      }

      const formatTime = (timeStr) => {
        return timeStr && timeStr.length === 5 ? `${timeStr}:00` : timeStr;
      };

      //console.log('applicableOffer', applicableOffer);  
      //console.log('order_type', order_type);  

      const {
          deliveryDate,
          deliveryEnd,
          deliveryStart,
          packingDate
      } = JSON.parse(deliveryInfo || "{}"), deliveryAttributes = {
          DeliveryDate: deliveryDate || "",
          PackingDate: packingDate || "",
          DeliveryStart: formatTime(deliveryStart) || "",
          DeliveryEnd: formatTime(deliveryEnd) || "",
          AddressType: "residential",
          promotional: ((order_type === "WeeklySubscription") || (order_type === "FortnightlySubscription")) ? applicableOffer : false,
          orderType: isSubscription.type
      };
      return {
          items: filteredCart,
          attributes: deliveryAttributes
      }
  }

  applicableDiscount(cartData, orderTypeN) {

    const { attributes = {}, total_price, items, original_total_price } = cartData;
    
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
      orderTypeN = "OneTimePurchase";
    }else{
      orderTypeN = attributes?.orderType?.type || "WeeklySubscription";
    }
    //alert(orderTypeN);
    if (orderTypeN === "OneTimePurchase") {
      //alert(11);
      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          //alert(12);
          return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(13);  
          return null;
      }else{
          const mealsCount = this.countLunchAndDinnerMeals(items);
          let discount;
          if (mealsCount >= oneTimeOffers.promo3.mealRange.max) {
                discount = oneTimeOffers.promo3.offerDiscount;
          } else if (mealsCount >= oneTimeOffers.promo2.mealRange.max) {
                discount = oneTimeOffers.promo2.offerDiscount;
        } else if (mealsCount >= oneTimeOffers.promo1.mealRange.max) {
                discount = oneTimeOffers.promo1.offerDiscount;
        }

        if(this.welcome25 && !isLogin){
          discount = 'WELCOME25';
        } 

        const offApplied = discount || null;
        return offApplied;
      }
    } else if (orderTypeN === "WeeklySubscription" || orderTypeN === "FortnightlySubscription") {
      //alert(12);
      if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          //alert(0);
          return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
          //alert(1);
          return null;
      }else if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("275Offer") && typeof customerData.ndisDiscountPercentage === "number") {
        //alert(2);
        const cartAmountInDollars = (total_price / 100).toFixed(2);
        const cartAmountInDollarsNumber = parseFloat(cartAmountInDollars); // Convert to number
        if (cartAmountInDollarsNumber >= 150 && cartAmountInDollarsNumber < 200) {
          return "5PERCENTOFF"; //EXISTING_SUBS_DIS5OFF;
        }
        if (cartAmountInDollarsNumber >= 200) {
          return "10PERCENTOFF"; //EXISTING_SUBS_DIS10OFF;
        }
      
      }else{          
        const responseMeals = this.countLunchAndDinnerMeals(items);
        const applicableOffer = this.getPromoForMeals(responseMeals);
        //alert(3);
        //alert(responseMeals);
        //alert(applicableOffer);
        if (applicableOffer === "promo1") {
          return null;
        } else if (applicableOffer === "promo2") {
          return "12MEALS_OFFER";
        } else if (applicableOffer === "promo3") {
          return "14MEALS_OFFER";
        } else if (applicableOffer === "promo4") {
          return "18MEALS_OFFER";
        }
        return null;
      }
    }
    return null;
  }

  updateCartAttrFromLocal(attributes){
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    })
    .then(res => res.json())
    .then(data => {
      //console.log('Cart attributes updated:', data);
    })
    .catch(err => {
      console.error('Error updating cart attributes:', err);
    });
  }
  

  proceedToCheckout(requestPath) {       
    this.continueToShipping(requestPath);
  }

  continueToShipping(requestPath) { 
    const button = document.getElementById("continue_to_shipping");
    //button?.classList.add("loading");
    try {        
      // STEP 1: Clear Shopify cart first        
      fetch("/cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } })
      
    .then(res => res.json())
    .then(data => {
        
        document.getElementById("loading-screen").style.display = "block";
        const cartData = this.getCartData(); 
        const { attributes, total_price, original_total_price } = cartData;
        const isNDIS = userLoggedIn && customerData?.tags?.includes("NDIS") && typeof customerData?.ndisDiscountPercentage === "number";
        const isKeto = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
        const orderType = isKeto ? "OneTimePurchase" : attributes?.orderType?.type || "WeeklySubscription";
        const discountCode = this.applicableDiscount(cartData, orderType);    
        const frequencySelect = document.getElementById("order-frequency");
        const selectedFrequency = frequencySelect?.value || "OneTimePurchase";
        //this.applicableDiscount(cartData, orderType);
        //return false; 

        const deliveryInfo = localStorage.getItem("deliveryInfo");
  
        // Create form data from localCart
        var formData = localCart.createFormData(deliveryInfo, {
          selling: !isKeto,
          type: isKeto ? "OneTimePurchase" : selectedFrequency
        });
  
        const cartItems = formData.items;
    
        const items = cartItems.map(item => {
          const cartItem = item;    
          if (selectedFrequency === "WeeklySubscription") {
            cartItem.selling_plan = SELLING_PLAN_S;   // Weekly plan ID
          } else if (selectedFrequency === "FortnightlySubscription") {
            cartItem.selling_plan = SELLING_PLAN_FS; // Fortnightly plan ID
          } else {
            cartItem.selling_plan = null; // One-time or other
          }

          cartItem.properties = {
            ...(cartItem.properties || {})
            //selectedFrequency: selectedFrequency
          };
          return cartItem;
        });

        //console.log(items); return;   

        //var all_attributes = formData.attributes;
        
        const mealsCount = this.countLunchAndDinnerMeals(localCart.getCartData().items);     
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(data => {
            // STEP 4: Build redirect URL
            const addressParams = this.validatedAddress();
            const queryString = Object.entries(addressParams)
              .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
              .join("&");
            const checkoutUrl = `${shopUrl}/checkout?${queryString}`;
            const redirectUrl = discountCode ? `${checkoutUrl}&discount=${discountCode}` : checkoutUrl;

            //console.log(all_attributes); return;
            //this.updateCartAttrFromLocal(all_attributes);
          
            // console.log(discountCode);
            //console.log(orderType);
            //return false;
          
            // STEP 5: Apply cart validation
            if (orderType === "OneTimePurchase") {    

              if(isKeto || isNDIS){
                //isNDIS users                             
                let acctual_total_price = original_total_price - ((original_total_price / 100) * customerData.ndisDiscountPercentage);
                acctual_total_price = acctual_total_price.toFixed(2);
                if (isNDIS && (acctual_total_price < MIN_NDIS_OTP_CART_AMOUNT)) { 
                  // console.log(`You need minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`);
                  document.getElementById("loading-screen").style.display = "none";
                  return this._showMinResponse(`Minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`, button);
                }  
                //isKeto users
                acctual_total_price = original_total_price - ((original_total_price / 100) * customerData.ketoCustDiscountFixed);
                acctual_total_price = acctual_total_price.toFixed(2);
                if (isKeto &&  (acctual_total_price < MIN_OTP_CART_AMOUNT)) {
                  
                  // console.log(`You need minimum $${MIN_OTP_CART_AMOUNT} to checkout`);
                  document.getElementById("loading-screen").style.display = "none";
                  return this._showMinResponse(`Minimum $${MIN_OTP_CART_AMOUNT} to checkout`, button);
                }
              }

              //Nornal User
              if (!isKeto && !isNDIS && total_price / 100 < MIN_OTP_CART_AMOUNT){
                // console.log(`You need minimum $${MIN_OTP_CART_AMOUNT} to checkout`);
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Minimum $${MIN_OTP_CART_AMOUNT} to checkout`, button); 
              }
              
              if (requestPath === "mini-cart") {
                window.location.href = redirectUrl; //isKeto ? redirectUrl : `${shopUrl}/pages/extras`;
              } else {
                window.location.href = redirectUrl;
              }
              
            } else if (orderType === "WeeklySubscription" || orderType === "FortnightlySubscription") {
              
              if (isNDIS && ((total_price / 100) < MIN_NDIS_SUBS_CART_AMOUNT)){
                // console.log(`You need minimum $${MIN_NDIS_SUBS_CART_AMOUNT} to subscribe`);
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Min Order. $${MIN_NDIS_SUBS_CART_AMOUNT} meals`, button);
              }
              if (mealsCount < MIN_SUBS_MEAL_LIMIT){
                // console.log(`You need minimum ${MIN_SUBS_MEAL_LIMIT} meals to subscribe`);
                document.getElementById("loading-screen").style.display = "none";
                return this._showMinResponse(`Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`, button);
              }
               // console.log(redirectUrl);
              window.location.href = redirectUrl;
            }
        });
    });
      //document.getElementById("loading-screen").style.display = "none";
    } catch (error) {
      console.error("Checkout Error:", error);
      document.getElementById("loading-screen").style.display = "none";
    } finally {
      //button?.classList.remove("loading");
      document.getElementById("loading-screen").style.display = "none";
    }
  }
  _showMinResponse(message, button) {
      if (message) {
          const responseEl = document.getElementById("min-response");
          responseEl && (responseEl.innerHTML = message), button?.classList.remove("loading")
      }
  }
  updateSubscription() {
      const cart = this.getCartData();

      const { total_price = 0, items = [] } = cart || {};
      
      const cartAmountInDollars = total_price / 100;
      
      const mealsCount = this.countLunchAndDinnerMeals(items);

      const { promoOffer = "", contractId = "", orderNo } = JSON.parse(subscriptionContractId || "{}");
      
      const normalizedPromoOffer = typeof promoOffer === "string" ? promoOffer.trim() : null;
      const isPromoOfferValid =
        normalizedPromoOffer &&
        normalizedPromoOffer !== "false" &&
        Object.prototype.hasOwnProperty.call(promotionalOffers, normalizedPromoOffer);

      document.querySelector(".minimum-text-info")?.classList.remove("d-none");
      if (isPromoOfferValid && (orderNo > 0 && orderNo < 5)) {
        const result = promotionalOffers[normalizedPromoOffer];
        if (result) {
          const { min = 0, max } = result.mealRange;
          if (mealsCount < max) {
            document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                  el.textContent = `Min Order. ${max} meals`;                    
            });
            return;
          } else {  
            document.querySelector(".minimum-text-info")?.classList.add("d-none");
          }
        }
      } else if (mealsCount < MIN_SUBS_MEAL_LIMIT) { 
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;                    
        });
        return;
      } else {
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
  
      // Contract ID check
      if (!contractId) {
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Something went wrong while subscription update. Please contact our support team.`;                    
        });
        return;
      } 

      const localItems = localCart.getCartData().items || [];
      const formData = {
        items: localItems.map(item => ({
          id: item.variant_id,
          quantity: item.quantity         
        }))
      };
      
      fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      })
      .then(() => {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData)
        });
      })
      .then(() => {
        // console.log({ localItems, formData });
        // alert("Cart synced successfully.");
        localStorage.setItem("proxy-contract-id", contractId);
        localStorage.removeItem("contractInfo");
        localStorage.removeItem("sub_cart_added");
        window.location.href = `/apps/account/contract/${contractId}/subscription-callback`;
      })
      .catch(err => {
        console.error("❌ Cart sync failed:", err);
      });
    
  }

  displayCartTotal() {
      this.updateCartInfoFromLocal(".cart-item-loop");
  }
  getOrdinalSuffix(number) {
      const lastDigit = number % 10,
          lastTwoDigits = number % 100;
      if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${number}th`;
      switch (lastDigit) {
          case 1:
              return `${number}st`;
          case 2:
              return `${number}nd`;
          case 3:
              return `${number}rd`;
          default:
              return `${number}th`
      }
  }
  subscriptionUpdateOffers(cart, totalPrice = null) { //alert('ss');
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      document.querySelectorAll(".frequency-selector").forEach(el => el.remove());
    
      $(".guest-order").remove();
      $(".update-subscription-btn").addClass("active");
      const mealsCount = this.countLunchAndDinnerMeals(cart.items);
      const cartAmountInDollars = totalPrice;
      //console.log('totalPrice', totalPrice);
    
      const {
        promoOffer = "",
        contractId = "",
        orderNo = 0,
      } = JSON.parse(subscriptionContractId || "{}");
    
      if (promoOffer && orderNo < 5) {
        const result = promotionalOffers[promoOffer] || null;
        if (result) {
            const { min = 0, max } = result.mealRange;
            if (mealsCount < max) {
                document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                    el.textContent = `Min Order. ${max} meals`;
                });
                document.querySelector(".minimum-text-info")?.classList.remove("d-none");
            }else{
              document.querySelector(".minimum-text-info")?.classList.add("d-none");
            }
          
          const offerList = document.querySelector(".offer-bar-footer .offer-list");
       
          offerList.innerHTML = "";
          
          const cartCounter = jQuery(".bigcounter");
          cartCounter.html(cart.item_count).addClass("added-cart-event"); 
    
          result.discounts.forEach((discount, index) => {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center","position-relative","custom-offerd-clc");
            const badgeSpan = document.createElement("span");
            badgeSpan.classList.add(
              "badge",
              (index >= orderNo)  ? "bg-secondary" : "bg-orange",
              "d-block","mb-2","position-absolute","right-0","small");
              badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
    
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded",
              "h2",
               (index >= orderNo)  ? "text-secondary" : "color-orange",
              "d-block","mb-2","mt-3");
    
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `$${discount} off`;
    
            const dashDiv = document.createElement("div");
            dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
    
            discountContentDiv.appendChild(badgeSpan);
            discountContentDiv.appendChild(iconElement);
            discountContentDiv.appendChild(discountDiv);
            offerList?.appendChild(discountContentDiv);
            offerList?.appendChild(dashDiv);
          });
    
        }
      }else if(mealsCount < MIN_SUBS_MEAL_LIMIT ) {
         document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
      }else{
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
      }
    
      document.querySelectorAll(".total-price-amount").forEach((el) => {
        el.textContent = `$${cartAmountInDollars.toFixed(2)}`;
      });
  }
  renderQuantitySelector(cart) {
      const productElements = document.querySelectorAll(".product-all"),
          items = cart.items;
      productElements.forEach(productElement => {
          const dataVariant = productElement.dataset.productId,
              quantitySelector = productElement.querySelector(".quantity-selector"),
              addToCartSelector = productElement.querySelector(".add-cart-button"),
              matchedItem = items.find(item => item.product_id === Number(dataVariant));
          if (matchedItem) {
              const quantity = matchedItem.quantity,
                  variantId = matchedItem.variant_id,
                  quantityText = productElement.querySelector(`.quantity-${variantId}`),
                  quantityInput = productElement.querySelector("input.qtyinputcs");
              quantityText && (quantityText.textContent = quantity), quantityInput && (quantityInput.value = quantity), quantitySelector && quantitySelector.classList.remove("d-none"), addToCartSelector && addToCartSelector.classList.add("d-none")
          } else addToCartSelector && addToCartSelector.classList.remove("d-none"), quantitySelector && quantitySelector.classList.add("d-none")
      })
  }

  backToSetDelivery(){
    if(isLogin){
      document.getElementById("border-topbg-white").style.display = "none";
      document.getElementById("cart-item-wrap").style.display = "none";
      document.getElementById("cart-item-title").style.display = "none";
      document.getElementById("finalflow").style.display = "block"; 
      document.getElementById("step1").classList.add('hidden');
      document.getElementById("step2").classList.remove('hidden');
    }else{
      document.getElementById("border-topbg-white").style.display = "none";
      document.getElementById("cart-item-wrap").style.display = "none";
      document.getElementById("cart-item-title").style.display = "none";
      document.getElementById("finalflow").style.display = "block";
    }
  }

  loadCartData(btnADD=null) {
    this.overwriteFromRemoteCart();
    return this.getCartData();
  }
  
  generateOfferDOM(cart, totalPrice) {
      const cartData = cart;
      const orderType = cartData.attributes?.orderType?.type || "WeeklySubscription";
      let cartDataNew;
      this.renderQuantitySelector(cartData);
  
      if (subscriptionContractId && userLoggedIn) {  
          const { total_price = 0, items = [] } = cart;
          this.subscriptionUpdateOffers(cart, totalPrice);
      } else {
          //console.log('Applying standard offers');
          document.querySelector(".menu-banner")?.classList.remove("d-none");
          $(".subtotal-title-area li:first-child").show();
          $(".subsciption-update").remove();
          $(".create-order-btn").addClass("active");
          localStorage.removeItem("contractInfo");
  
          // NDIS customer check
          if (
              userLoggedIn &&
              Array.isArray(customerData.tags) &&
              customerData.tags.includes("NDIS") &&
              typeof customerData.ndisDiscountPercentage === "number"
          ) {
              if (orderType === "OneTimePurchase") {
                  //console.log(cartData);
                  //console.log(totalPrice);
                  this.NDISoneTimePurchaseOffers(cartData, totalPrice);
              } else if (["WeeklySubscription", "FortnightlySubscription"].includes(orderType)) {
                  this.NDISsubscriptionOffers(cartData, totalPrice);
              }
          }
  
          // Keto customer check
          else if (
              userLoggedIn &&
              Array.isArray(customerData.tags) &&
              ((customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") || customerData.tags.includes("T1") || customerData.tags.includes("T2")  || customerData.tags.includes("T3"))
              
          ) {
              //console.log(totalPrice);
              this.KetoOneTimePurchaseOffers(cartData, totalPrice);
          }
  
          // Regular offers
          else {
              if (orderType === "OneTimePurchase") {
                  this.oneTimePurchaseOffers(cartData, totalPrice);
              } else if (["WeeklySubscription", "FortnightlySubscription"].includes(orderType)) {
                  this.subscriptionOffers(cartData, totalPrice);
              }
          }
      }
      document.getElementById("mini-cart").style.display = "block";
  }
  oneTimePurchaseOffers({
      original_total_price,
      items
  }, totalPrice) {
      const offerLists = document.querySelectorAll(".offer-list");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".per-serving-section")?.classList.add("d-none");
      
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".free-shipping-text")?.classList.add("d-none");
      
      
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerLists) {
        //console.error('Element with id "offer-list" not found');
        //return;
      }
      const cartAmountInDollars = original_total_price / 100;
       if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
         if (primaryButton) {
            primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
            primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
            primaryButton.innerHTML = `Add $${(MIN_OTP_CART_AMOUNT - cartAmountInDollars).toFixed(2)} more to your cart`;
        }    
         document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. Value $${MIN_OTP_CART_AMOUNT}`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
    
      } else {
         if (primaryButton) {
            const deliveryDate = getCookie("expecting-delivery");
            if (deliveryDate !== null) {
                primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
                primaryButton.classList.add("bg-orange","border-orange");
                primaryButton.innerHTML = 'Checkout Now';
            } else {
                primaryButton.removeAttribute("onclick");
                primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
                primaryButton.classList.add("checkPostalBtn2");
                primaryButton.innerHTML = 'Select Delivery Date and Checkout';
            }
         }
      }
      
      let notificationMessage = "Save up to 10% on Meals";
      let activeOffer=null;
      const basePrice = cartAmountInDollars.toFixed(2);
     
      offerLists.forEach((list) => (list.innerHTML = ""));
      const mealsCount = this.countLunchAndDinnerMeals(items);
    
      if (offerListDetails) {
        offerListDetails.innerHTML = "";
      }
      let bestOffer = false;
      let totalDiscount = 0;
      let prevPromo=null;
    
      // console.log(oneTimeOffers, mealsCount, original_total_price);
    
      Object.entries(oneTimeOffers).forEach(([promo, offer]) => {
        
        const { min, max } = offer.mealRange;
        totalDiscount = offer.discounts; //Math.round(offer.discounts.reduce((a, b) => a + b, 0));
        const li = document.createElement("li");
        const isBestOffer = mealsCount >= max;
        li.classList.add("me-2","d-flex","align-items-center","rounded-pill", isBestOffer ? "bg-gradient-success" : "bg-off-grey");
        bestOffer = isBestOffer;
    
        if (mealsCount >= min && (max === null || mealsCount < max)) {
          notificationMessage= `${notificationMessage} <br><span class="small text-muted fs-12">${offer.notify}</span>`;
    
          const maxRange = max === null ? mealsCount : max;
          const widthPercentage = Math.min((mealsCount / maxRange) * 100, 100);
    
          const progressDiv = document.createElement("div");
          progressDiv.classList.add("d-flex","align-items-center","justify-end","rounded-pill","bg-gradient-success-secondary");
          progressDiv.style.transition = "width 1s";
          progressDiv.style.minWidth = "max-content";
          progressDiv.style.zIndex = "1";
          progressDiv.style.width = `${widthPercentage}%`;
    
          const innerDiv = document.createElement("div");
          innerDiv.classList.add("d-flex","align-items-center","justify-center","rounded-pill","bg-white","color-green","border-green","px-2","dynamic-margin","py-sm-0","py-1");
          innerDiv.textContent = `${mealsCount}/${maxRange}`;
    
          progressDiv.appendChild(innerDiv);
          li.style.width = "100%";
          li.classList.add("position-relative", "bg-off-grey");
          li.appendChild(progressDiv);
    
          const span = document.createElement("span");
          span.classList.add("position-absolute","right-0","text-dark","px-1","py-sm-0","py-1");
          span.textContent = `${totalDiscount}%OFF`;
          li.appendChild(span);
         
          if (prevPromo && prevPromo.discounts && prevPromo.discounts.length > 0) {
          activeOffer=prevPromo;
          prevPromo.discounts.forEach((discount, index) => {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center","position-relative","custom-offerd-clc");
    
            const badgeSpan = document.createElement("span");
            badgeSpan.classList.add("badge","bg-orange","d-block","mb-2","position-absolute","right-0","small");
            
            badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded","h2","color-orange","d-block","mb-2","mt-3");
    
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `$${discount}OFF`;
    
            const dashDiv = document.createElement("div");
            dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
    
            discountContentDiv.appendChild(badgeSpan);
            discountContentDiv.appendChild(iconElement);
            discountContentDiv.appendChild(discountDiv);
            offerListDetails?.appendChild(discountContentDiv);
            offerListDetails?.appendChild(dashDiv);
          });
        }else{
            const span = document.createElement("span");
            span.classList.add("fw-bold", "text-black", "py-2");
            span.textContent = "Save up to 10% on Meals";
            offerListDetails?.appendChild(span);
        }
        } else {
          const span = document.createElement("span");
          span.classList.add("rounded-pill","top-0","right-0","text-dark","p-1","text-white","text-center");
          span.textContent = `${totalDiscount}%${!isBestOffer ? 'OFF' : ''}`;
          li.appendChild(span);
        }
        prevPromo = offer;
         
        offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
      });

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");

      //console.log(localStorage.getItem("WELCOME25_APPLIED"));

      if(localStorage.getItem("WELCOME25_APPLIED") && (state.plan === "onetime")){

        bestOffer = false;

        let amountDollars = 25.00;
        let formatted = amountDollars.toLocaleString("en-AU", {
          style: "currency",
          currency: "AUD",
        });

        totalPrice = ((original_total_price / 100)).toFixed(2) - amountDollars; 

        // 🔹 Create / show extra row
        if (!extraRow) {
          extraRow = document.createElement("div");
          extraRow.className =
            "welcome25-extra-row d-flex justify-content-between mt-1 small";
          // show directly under existing discount-section
          discountSectionPrev.insertAdjacentElement("afterend", extraRow);
        }

        extraRow.innerHTML = `
          <label class="fs-12">Discount code (WELCOME25)</label>
          <span class="badge rounded-pill bg-orange fw-bold discount-amount">-${formatted}</span>
        `;
        extraRow.style.display = "";
        
        discountSectionPrev?.classList.add('strick_through');
        offerListSection?.classList.add('shadow_row');   

      }else{  

          if (extraRow) extraRow.remove();
          discountSectionPrev?.classList.remove('strick_through');
          offerListSection?.classList.remove('shadow_row');

      }

      if (bestOffer) {

        offerLists.forEach((list) => (list.innerHTML = "")); // Clear the list before appending the best offer
        const li = document.createElement("li");
        li.classList.add("me-2","d-flex","align-items-center","rounded-pill","bg-gradient-success");
        li.style.width = "100%";
        const span = document.createElement("span");
        span.classList.add("px-2","py-1","rounded-pill","top-0","right-0","text-dark","p-1","text-white","text-center");
        span.textContent = `You’re saving 10% on Meals🎉`; // Insert the total discount value
        li.appendChild(span);
        activeOffer=oneTimeOffers.promo3;
        offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));

      }
      document.querySelector(".offer-details-bar")?.classList.remove("d-none");
    
        document.querySelectorAll(".notification-message-mini-cart").forEach((el) => {
        el.innerHTML = notificationMessage;  // Use textContent if it's plain text
      });
      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = `$${(original_total_price / 100).toFixed(2)}`;
      
      document.querySelectorAll(".total-price-amount").forEach((el) => {
              el.textContent = `$${totalPrice.toFixed(2)}`;
      });
      const offApplied = ((original_total_price / 100)- totalPrice).toFixed(2);
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-$${offApplied}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
  }
  

  subscriptionOffers({ original_total_price, items, total_count }, totalPrice) {
    const offerLists = document.querySelectorAll(".offer-list");
    const offerListDetails = document.getElementById("offer-list-details");
  
    document.querySelector(".free-shipping-section")?.classList.remove("d-none");
    document.querySelector(".free-shipping-text")?.classList.remove("d-none");
    document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
    document.querySelector(".free-shipping-amount")?.classList.remove("fw-bold");
    document.querySelector(".free-shipping-text")?.classList.add("fw-bold");
    document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    if (!offerLists) {
      console.error('Element with class "offer-list" not found');
      return;
    }
  
    const cartAmountInDollars = totalPrice;
    const mealsCount = this.countLunchAndDinnerMeals(items);
  
    if ((mealsCount < MIN_SUBS_MEAL_LIMIT) || (cartAmountInDollars < MIN_SUBS_CART_AMOUNT)) {
      if (primaryButton) {
        primaryButton.removeAttribute("onclick", "javascript:void(0);");
        primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
      }      
      
      let frist_have = 0;
      if (mealsCount < MIN_SUBS_MEAL_LIMIT){
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;
        });
        if (primaryButton) {
            primaryButton.innerHTML = `Add <b>${(MIN_SUBS_MEAL_LIMIT - mealsCount)}</b> more meals to your cart to continue`;
        }
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        frist_have = 1;
      } else{
        frist_have = 0;
      }
      
      if ((cartAmountInDollars < MIN_SUBS_CART_AMOUNT) && !frist_have){
        if (primaryButton) {
          primaryButton.innerHTML = `Add <b>$${(MIN_SUBS_CART_AMOUNT - cartAmountInDollars).toFixed(2)}</b> more to your cart`;
        }
        document.querySelectorAll(".total-minimum-limit").forEach((el) => {
              el.textContent = `Min Order. Value $${MIN_SUBS_CART_AMOUNT}`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
      }
      
    } else {
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      const deliveryDate = getCookie("expecting-delivery");
      if (primaryButton) {
        if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.innerHTML = 'Checkout Now';
          primaryButton.classList.add("bg-orange", "border-orange");
        } else {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
          primaryButton.innerHTML = 'Select Delivery Date and Checkout';
        }
      }
    }
  
    let notificationMessage = "Save up to $275 on Meals and Delivery";
    let activeOffer = null;
    const basePrice = cartAmountInDollars.toFixed(2);
  
    offerLists.forEach(list => (list.innerHTML = ""));
    if (offerListDetails) offerListDetails.innerHTML = "";
  
    let bestOffer = false;
    let totalDiscount = 0;
    let prevPromo = null;
  
    Object.entries(promotionalOffers).forEach(([promo, offer]) => {
      const { min, max } = offer.mealRange;
  
      totalDiscount = promo === "promo1"
        ? "FREE SHIPPING"
        : `$${Math.round(offer.discounts.reduce((a, b) => a + b, 0))}`;
  
      const li = document.createElement("li");
      const isBestOffer = mealsCount >= max;
      li.classList.add("me-2", "d-flex", "align-items-center", "rounded-pill",
        isBestOffer ? "bg-gradient-success" : "bg-off-grey");
      bestOffer = isBestOffer;
  
      if (mealsCount >= min && (max === null || mealsCount < max)) {
        notificationMessage += `<br><span class="small text-muted fs-12">${mealsCount < 10 ? "FREE SHIPPING on all recurring deliveries" : offer.notify}</span>`;
  
        const maxRange = max === null ? mealsCount : max;
        const widthPercentage = Math.min((mealsCount / maxRange) * 100, 100);
  
        const progressDiv = document.createElement("div");
        progressDiv.classList.add("d-flex", "align-items-center", "justify-end", "rounded-pill", "bg-gradient-success-secondary");
        progressDiv.style.transition = "width 1s";
        progressDiv.style.minWidth = "max-content";
        progressDiv.style.zIndex = "1";
        progressDiv.style.width = `${widthPercentage}%`;
  
        const innerDiv = document.createElement("div");
        innerDiv.classList.add("d-flex", "align-items-center", "justify-center", "rounded-pill", "bg-white", "color-green", "border-green", "px-2", "dynamic-margin", "py-sm-0", "py-1");
        innerDiv.textContent = `${mealsCount}/${maxRange}`;
  
        progressDiv.appendChild(innerDiv);
        li.style.width = "100%";
        li.classList.add("position-relative", "bg-off-grey");
        li.appendChild(progressDiv);
  
        const span = document.createElement("span");
        span.classList.add("position-absolute", "right-0", "text-dark", "px-1", "py-sm-0", "py-1");
        span.textContent = totalDiscount;
        li.appendChild(span);
  
        if (prevPromo?.discounts?.length) {
          activeOffer = prevPromo;
          prevPromo.discounts.forEach((discount, index) => {
            const discountContentDiv = document.createElement("div");
            discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
  
            const badgeSpan = document.createElement("span");
            badgeSpan.classList.add("badge", "bg-orange", "d-block", "mb-2", "position-absolute", "right-0", "small");
            badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
  
            const iconElement = document.createElement("i");
            iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
  
            const discountDiv = document.createElement("div");
            discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
            discountDiv.textContent = `$${discount} off`;
  
            const dashDiv = document.createElement("div");
            dashDiv.classList.add("border-top", "border-secondary", "dashed-line");
  
            discountContentDiv.append(badgeSpan, iconElement, discountDiv);
            offerListDetails?.append(discountContentDiv, dashDiv);
          });
        } else {
          const span = document.createElement("span");
          span.classList.add("fw-bold", "text-black", "py-2");
          span.textContent = "Save up to $275 on Meals and Delivery";
          offerListDetails?.appendChild(span);
        }
      } else {
        const span = document.createElement("span");
        span.classList.add("rounded-pill", "top-0", "right-0", "text-dark", "p-1", "text-white", "text-center");
        span.textContent = totalDiscount;
        li.appendChild(span);
      }
  
      prevPromo = offer;
      offerLists.forEach(list => list.appendChild(li.cloneNode(true)));
    });

    let extraRow = document.querySelector(".welcome25-extra-row");
    let totalEls = document.querySelectorAll(".total-price-amount");
    let discountSectionPrev = document.querySelector(".discount-section");
    let offerListSection = document.querySelector(".offer-list-section");
    
    if (extraRow) extraRow.remove();
    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
  
    if (bestOffer) {
      this.renderlastOffer(promotionalOffers.promo4);
      offerLists.forEach(list => (list.innerHTML = ""));
      const li = document.createElement("li");
      li.classList.add("me-2", "d-flex", "align-items-center", "rounded-pill", "bg-gradient-success");
      li.style.width = "100%";
  
      const span = document.createElement("span");
      span.classList.add("px-2", "py-1", "rounded-pill", "top-0", "right-0", "text-dark", "p-1", "text-white", "text-center");
      span.textContent = `You’re saving ${totalDiscount} 🎉`;
      li.appendChild(span);
  
      activeOffer = promotionalOffers.promo4;
      offerLists.forEach(list => list.appendChild(li.cloneNode(true)));
    }
  
    document.querySelector(".offer-details-bar")?.classList.remove("d-none");
  
    const offApplied = activeOffer?.discounts?.[0] || 0;
    const discountedPrice = (cartAmountInDollars - offApplied).toFixed(2);
  
    document.querySelectorAll(".total-price-amount").forEach(el => {
      el.textContent = `$${discountedPrice}`;
    });
  
    document.querySelector(".total-applied-section")?.classList.toggle("d-none", !activeOffer);
    document.querySelectorAll(".notification-message-mini-cart").forEach(el => {
      el.innerHTML = notificationMessage;
    });
  
    document.querySelector(".sub-total-section")?.classList.remove("d-none");
    document.querySelector(".sub-total-amount").textContent = `$${cartAmountInDollars.toFixed(2)}`;
  
    const discountSection = document.querySelector(".discount-section");
    const discountAmountEl = document.querySelector(".discount-amount");
  
    if (offApplied > 0) {
      discountSection?.classList.remove("d-none");
      discountAmountEl && (discountAmountEl.textContent = `-$${offApplied}`);
    } else {
      discountSection?.classList.add("d-none");
      discountAmountEl && (discountAmountEl.textContent = "");
    }
  }

  
  renderlastOffer(prevPromo) {
      const offerListDetails = document.getElementById("offer-list-details");
      !offerListDetails || !Array.isArray(prevPromo?.discounts) || prevPromo.discounts.forEach((discount, index) => {
          const discountContentDiv = document.createElement("div");
          discountContentDiv.classList.add("text-center", "position-relative", "custom-offerd-clc");
          const badgeSpan = document.createElement("span");
          badgeSpan.classList.add("badge", "bg-orange", "d-block", "mb-2", "position-absolute", "right-0", "small"), badgeSpan.textContent = this.getOrdinalSuffix(index + 1);
          const iconElement = document.createElement("i");
          iconElement.classList.add("icon-basket-loaded", "h2", "color-orange", "d-block", "mb-2", "mt-3");
          const discountDiv = document.createElement("div");
          discountDiv.classList.add("small", "text-uppercase", "fw-bolder"), discountDiv.textContent = `$${discount} off`;
          const dashDiv = document.createElement("div");
          dashDiv.classList.add("border-top", "border-secondary", "dashed-line"), discountContentDiv.appendChild(badgeSpan), discountContentDiv.appendChild(iconElement), discountContentDiv.appendChild(discountDiv), offerListDetails.appendChild(discountContentDiv), offerListDetails.appendChild(dashDiv)
      })
  }
  KetoOneTimePurchaseOffers({
      original_total_price,
      items,
      item_count,
      total_count
  }, totalPrice) {
      const offerLists = document.querySelectorAll(".offer-list");
      document.querySelector(".total-applied-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.remove("text-decoration-line-through");
      document.querySelector(".free-shipping-section")?.classList.add("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("fw-bold");
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      document.querySelectorAll(".frequency-selector").forEach(el => el.remove());
    
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerListDetails) {
        //console.error('Element with id "offer-list-details" not found');
        //return;
      }      

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");
      
      if (extraRow) extraRow.remove();
      discountSectionPrev?.classList.remove('strick_through');
      offerListSection?.classList.remove('shadow_row');
    
      const cartAmountInDollars = (totalPrice).toFixed(2);
    
      if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
        if (primaryButton) {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.remove("checkPostalBtn2", "bg-orange", "border-orange");
          primaryButton.innerHTML = `Add $${(MIN_OTP_CART_AMOUNT - cartAmountInDollars).toFixed(2)} more to your cart`;
        }
        document.querySelectorAll(".total-minimum-limit").forEach(el => {
          el.textContent = `Min Order. Value $${MIN_OTP_CART_AMOUNT}`;
        });
        document.querySelector(".minimum-text-info")?.classList.remove("d-none");
      } else {
        if (primaryButton) {
          const deliveryDate = getCookie("expecting-delivery");
          if (deliveryDate !== null) {
            primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
            primaryButton.classList.add("bg-orange", "border-orange");
            primaryButton.innerHTML = "Checkout Now";
          } else {
            primaryButton.removeAttribute("onclick");
            primaryButton.classList.add("checkPostalBtn2");
            primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
            primaryButton.innerHTML = "Select Delivery Date and Checkout";
          }
        }
      }

      //console.log('original_total_price', original_total_price);

      const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-$${offApplied}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
    
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-text")?.classList.add("d-none");
    
      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = `$${(original_total_price / 100).toFixed(2)}`;
    
      document.querySelectorAll(".total-price-amount").forEach(el => {
        el.textContent = `$${cartAmountInDollars}`;
      });
  }

  NDISoneTimePurchaseOffers({
      original_total_price,
      items
  }, totalPrice) {
    const cartAmountInDollars = (totalPrice).toFixed(2);
    //console.log(cartAmountInDollars, MIN_NDIS_OTP_CART_AMOUNT);
    const offerLists = document.querySelectorAll(".offer-list");
  
    document.querySelector(".total-applied-section")?.classList.add("d-none");
  
    document.querySelector(".free-shipping-section")?.classList.remove("d-none");
    document.querySelector(".free-shipping-text")?.classList.remove("d-none");
    document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
    document.querySelector(".free-shipping-text")?.classList.add("fw-bold");
  
    document.querySelector(".minimum-text-info")?.classList.add("d-none");
  
    const offerListDetails = document.getElementById("offer-list-details");
    if (!offerLists) {
      //console.error('Element with class "offer-list" not found');
      return;
    }
  
    // Conditional CTA button logic
    if (cartAmountInDollars < MIN_NDIS_OTP_CART_AMOUNT) { 
      if (primaryButton) {
        primaryButton.removeAttribute("onclick");
        primaryButton.classList.remove("checkPostalBtn2", "bg-orange", "border-orange");
        primaryButton.innerHTML = `Add $${(MIN_NDIS_OTP_CART_AMOUNT - cartAmountInDollars).toFixed(2)} more to your cart`;
      }
  
      document.querySelectorAll(".total-minimum-limit").forEach(el => {
        el.textContent = `Min Order. Value $${MIN_NDIS_OTP_CART_AMOUNT}`;
      });
  
      document.querySelector(".minimum-text-info")?.classList.remove("d-none");
  
    } else {
      if (primaryButton) {
        const deliveryDate = getCookie("expecting-delivery");
  
        if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.classList.add("bg-orange", "border-orange");
          primaryButton.innerHTML = "Checkout Now";
        } else {
          primaryButton.removeAttribute("onclick");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
          primaryButton.innerHTML = "Select Delivery Date and Checkout";
        }
      }
    }

    let extraRow = document.querySelector(".welcome25-extra-row");
    let totalEls = document.querySelectorAll(".total-price-amount");
    let discountSectionPrev = document.querySelector(".discount-section");
    let offerListSection = document.querySelector(".offer-list-section");
    
    if (extraRow) extraRow.remove();
    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
  
    // Subtotal + Total price display
    document.querySelector(".sub-total-section")?.classList.remove("d-none");
    document.querySelector(".sub-total-amount").textContent = `$${(original_total_price/100).toFixed(2)}`;
  
     document.querySelectorAll(".total-price-amount").forEach((el) => {
            el.textContent = `$${(totalPrice).toFixed(2)}`;
    });
    const discountSection = document.querySelector(".discount-section");
    const discountAmountEl = document.querySelector(".discount-amount");
    const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
    if (offApplied > 0) {
      discountSection?.classList.remove("d-none");
      discountAmountEl && (discountAmountEl.textContent = `-$${offApplied}`);
    } else {
      discountSection?.classList.add("d-none");
      discountAmountEl && (discountAmountEl.textContent = "");
    }
  }

  
  NDISsubscriptionOffers({
      original_total_price,
      items
  }, totalPrice) {
      
      const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
      document.querySelector(".minimum-text-info")?.classList.add("d-none");
      let mealsCount = this.countLunchAndDinnerMeals(items);
      
      document.querySelector(".free-shipping-section")?.classList.remove("d-none");
      document.querySelector(".free-shipping-text")?.classList.remove("d-none");
      document.querySelector(".free-shipping-amount")?.classList.add("text-decoration-line-through");
      document.querySelector(".free-shipping-text")?.classList.add('fw-bold');
      document.querySelector("#min-response")?.classList.remove("d-none");
      
      const offerListDetails = document.getElementById("offer-list-details");
      if (!offerLists) {
        //console.error('Element with id "offer-list" not found');
        return;
      }
      const cartAmountInDollars = totalPrice;
      if ((cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) || (mealsCount < MIN_SUBS_MEAL_LIMIT)) {
        if (primaryButton) {
          //primaryButton.removeAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
          primaryButton.removeAttribute("onclick", "javascript:void(0);");
          primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        }
        let frist_have = 0;
        if (mealsCount < MIN_SUBS_MEAL_LIMIT){
          document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;
          });
          if (primaryButton) {
              primaryButton.innerHTML = `Add <b>${(MIN_SUBS_MEAL_LIMIT - mealsCount)}</b> more meals to your cart to continue`;
          }
          document.querySelector(".minimum-text-info")?.classList.remove("d-none");
          frist_have = 1;
        } else{
          frist_have = 0;
        }
        
        if((cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) && !frist_have){
          if (primaryButton) {
            primaryButton.innerHTML = `Add <b>$${(MIN_NDIS_SUBS_CART_AMOUNT - cartAmountInDollars).toFixed(2)}</b> more to your cart`;
          }
          document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                el.textContent = `Min Order. Value $${MIN_NDIS_SUBS_CART_AMOUNT}`;
          });
          document.querySelector(".minimum-text-info")?.classList.remove("d-none");
        }

        //console.log(mealsCount+' ===11 '+MIN_SUBS_MEAL_LIMIT);
        
        if (mealsCount < MIN_SUBS_MEAL_LIMIT){
          document.querySelectorAll(".total-minimum-limit").forEach((el) => {
                el.textContent = `Min Order. ${MIN_SUBS_MEAL_LIMIT} meals`;
          });
          document.querySelector(".minimum-text-info")?.classList.remove("d-none"); 
          //this._showMinResponse(`You need minimum ${MIN_SUBS_MEAL_LIMIT} meals to subscribe`, primaryButton);
        } 
        
      } else {
        
        document.querySelector(".minimum-text-info")?.classList.add("d-none");
        //console.log(mealsCount+' ===12 '+MIN_SUBS_MEAL_LIMIT);        
        
        if (primaryButton) {
          const deliveryDate =  getCookie("expecting-delivery");
          if (deliveryDate !== null) {
              primaryButton.setAttribute("onclick", "localCart.proceedToCheckout('mini-cart')");
              primaryButton.innerHTML = 'Checkout Now';
              primaryButton.classList.add("bg-orange","border-orange");
          } else {
              primaryButton.removeAttribute("onclick");
              primaryButton.classList.add("checkPostalBtn2");
              primaryButton.setAttribute("onclick", "localCart.backToSetDelivery('mini-cart')");
              primaryButton.innerHTML = 'Select Delivery Date and Checkout';
          }
        }
      }

      let extraRow = document.querySelector(".welcome25-extra-row");
      let totalEls = document.querySelectorAll(".total-price-amount");
      let discountSectionPrev = document.querySelector(".discount-section");
      let offerListSection = document.querySelector(".offer-list-section");
      
      if (extraRow) extraRow.remove();
      discountSectionPrev?.classList.remove('strick_through');
      offerListSection?.classList.remove('shadow_row');

      document.querySelector(".sub-total-section")?.classList.remove("d-none");
      document.querySelector(".sub-total-amount").textContent = `$${(original_total_price/100).toFixed(2)}`;
     
      document.querySelectorAll(".total-price-amount").forEach((el) => {
              el.textContent = `$${(totalPrice).toFixed(2)}`;
      });
      const discountSection = document.querySelector(".discount-section");
      const discountAmountEl = document.querySelector(".discount-amount");
      const offApplied = ((original_total_price/100) - totalPrice).toFixed(2);
      if (offApplied > 0) {
        discountSection?.classList.remove("d-none");
        discountAmountEl && (discountAmountEl.textContent = `-$${offApplied}`);
      } else {
        discountSection?.classList.add("d-none");
        discountAmountEl && (discountAmountEl.textContent = "");
      }
  }
}

const localCart = new LocalCart;

document.addEventListener("DOMContentLoaded", function () { 
  const sub_cart_added = localStorage.getItem("sub_cart_added");
  if (subscriptionContractId && userLoggedIn && !sub_cart_added) {
    localCart.overwriteFromRemoteCart().then(newCart => {
      localStorage.setItem("sub_cart_added",1);
      localCart.updateCartInfoFromLocal(".cart-item-loop");
      let preWrapNew = document.querySelector("#pre_selected_data_wrap");
      preWrapNew?.classList.add("hidden");
    });
  }else{
    localCart.updateCartInfoFromLocal(".cart-item-loop");
  }
  const isKetoUser = userLoggedIn && customerData?.tags?.includes("keto_customers") && typeof customerData?.ketoCustDiscountFixed === "number";
  
  if (!frequencySelect) return;
  
  frequencySelect.addEventListener("change", function () {
    const selectedValue = frequencySelect.value;
    if (selectedValue === "OneTimePurchase") {
      document.querySelector("#min-response")?.classList.add("d-none");
    }
  });
  
  if(isKetoUser){    
    frequencySelect.value = "OneTimePurchase";
    const changeEvent = new Event("change", { bubbles: true });
    frequencySelect.dispatchEvent(changeEvent);  
    document.querySelector(".frequency-selector")?.classList.add("d-none"); // ⬅️ Hides the dropdown
    document.querySelector("#min-response")?.classList.add("d-none");
  }
});

$(document).on("click", ".product-quantity .qtybutton", function() {
  const $button = $(this),
      action = $button.data("action"),
      $qtySpan = $button.siblings(".cusqtyspan"),
      oldQty = parseInt($qtySpan.text(), 10),
      newQty = action === "+" ? oldQty + 1 : Math.max(0, oldQty - 1);
  // console.log(newQty+' ===');
  $qtySpan.html(newQty);
  $button.siblings("input").val(newQty);
  const $productQuantity = $button.closest(".product-quantity"),
      variantId = parseInt($productQuantity.data("variant"), 10),
      quantityElement = $button.siblings(".cusqtyspan");
      $productQuantityAction = $button.closest(".product-quantity-action");  
  localCart.changeInToLocalCart(variantId, newQty, $productQuantityAction);
  localCart.updateCartInfoFromLocal(".cart-item-loop");
});

document.addEventListener("DOMContentLoaded", () => {
  const getCart = localCart.getCartData();
  const orderType = getCart?.attributes?.orderType?.type;
  if (orderType) {
    if (frequencySelect) {
      frequencySelect.value = orderType;
    }
  }
  //updateWelcome25Row();
}); 

async function updateWelcome25Row() {
  const discountSectionNEW = document.querySelector(".discount-section");
  if (!discountSectionNEW) return;

  let extraRow = document.querySelector(".welcome25-extra-row");
  const totalEls = document.querySelectorAll(".total-price-amount");
  const discountSectionPrev = document.querySelector(".discount-section");
  const offerListSection = document.querySelector(".offer-list-section");
  let getCartData = localStorage.getItem('localCart');
  let getCartDataType = getCartData?.attributes?.orderType?.type || 'OneTimePurchase';

  //console.log('getCartData',getCartData);
  //console.log('getCartDataType',getCartDataType);

  try {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await res.json();

    const app = (cart.cart_level_discount_applications || []).find(
      a => a.title === "WELCOME25" || a.code === "WELCOME25"
    );

    const amountCents = app ? (app.total_allocated_amount || 0) : 0;
    const amountDollars = amountCents / 100;
    //console.log('amountCents', amountCents);

    if ((amountCents > 0) && (getCartDataType == 'OneTimePurchase')) {

      const formatted = amountDollars.toLocaleString("en-AU", {
        style: "currency",
        currency: "AUD",
      });

      // 🔹 Create / show extra row
      if (!extraRow) {
        extraRow = document.createElement("div");
        extraRow.className =
          "welcome25-extra-row d-flex justify-content-between mt-1 small";
        // show directly under existing discount-section
        discountSectionNEW.insertAdjacentElement("afterend", extraRow);
      }

      extraRow.innerHTML = `
        <label class="fs-12">Discount code (WELCOME25)</label>
        <span class="badge rounded-pill bg-orange fw-bold discount-amount">-${formatted}</span>
      `;
      extraRow.style.display = "";

      // 🔹 Adjust totals (base total is stored in data-base-total)
      totalEls.forEach(el => {
        if (!el.dataset.baseTotal) {
          // save current as base total once
          const raw = (el.textContent || "").replace(/[^0-9.-]+/g, "");
          if (!raw) return;
          el.dataset.baseTotal = raw;
        }
        const base = parseFloat(el.dataset.baseTotal);
        if (!Number.isFinite(base)) return;

        const discounted = base - amountDollars;
        el.textContent = `$${discounted.toFixed(2)}`;
      });
      discountSectionPrev?.classList.add('strick_through');
      offerListSection?.classList.add('shadow_row');

      if(localStorage.getItem("WELCOME25_APPLIED")){
        localStorage.removeItem("WELCOME25_APPLIED");
        location.reload();
      }
      
    }
  } catch (e) {

    console.error("WELCOME25 update error:", e);
    if (extraRow) extraRow.remove();
    discountSectionPrev?.classList.remove('strick_through');
    offerListSection?.classList.remove('shadow_row');
    localStorage.removeItem("WELCOME25_APPLIED");

  }
}


function changeInToCart(variantId, quantity, quantityElement=null, $productQuantityAction=null,  localCart=null) {
    $productQuantityAction?.addClass('loading');
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
            quantity: quantity,
            id: variantId
        },
        success: function(data) {
          $productQuantityAction?.removeClass('loading');
          localCart.updateCartInfoFromLocal(".cart-item-loop");
        },
        error: function(error) {
            console.error("Error adding to cart: ", error);
           if (quantityElement) {
              quantityElement.text(quantityElement.data('original-value')); // Revert to original value on error
          }
           $productQuantityAction?.removeClass('loading');
        }
    });
}

function clearCartData() {
  return fetch("cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(clearCart => {
      // console.log('Success:', clearCart);
      localCart.updateCartInfoFromLocal(".cart-item-loop");
      localStorage.removeItem("contractInfo");
      window.location.href = `/collections/fresh-ready-meals`;
    })
    .catch((error) => {
      console.error("Error clearing cart:", error);
      throw error; // Rethrow the error for further handling
    });
}


/* ------------------------------------------------------------------
   Checkout validator (custom page → Shopify checkout)
   - Validates email, phone, address, delivery date/time, plan(+freq)
   - Saves: cartAttributes, deliveryInfo, widgetAddress
   - Calls: localCart.continueToShipping(requestPath)
  ------------------------------------------------------------------- */
  window.checkoutValidate = function checkoutValidate(requestPath = "mini-cart") {
    const vEmail = v => /\S+@\S+\.\S+/.test(String(v||""));
    const vPhone = v => String(v||"").replace(/\D/g,"").length >= 8;
    const vAddr  = v => String(v||"").trim().length >= 6;
    const qs     = (s, r=document) => r.querySelector(s);
    
    const window_state   = JSON.parse(localStorage.getItem("window_state")   || "{}");

    // read from your global `state` first; fall back to DOM fields
    //const email   = (window.state?.email   || (qs("#email2")?.value || qs("#email1")?.value || "")).trim();
    const phone   = (window.state?.phone   || (qs("#phone2")?.value || qs("#phone1")?.value || "")).trim();
    const address = (window.state?.address || (qs("#address2")?.value || qs("#address1")?.value || "")).trim();

    const dateStr = (window.state?.date || (window_state?.date || "")).trim();
    const timeStr = (window.state?.time || (window_state?.time || "")).trim();
    const plan    = (window.state?.plan || (window_state?.plan || "")).trim();           // "subscribe" | "onetime"
    const freq    = (window.state?.freq || (window_state?.freq || "")).trim();           // "weekly" | "fortnightly" | ""

    //if (!vEmail(email))  { alert("Please enter a valid email."); return false; }
    /*if (!vPhone(phone))  { alert("Please enter a valid phone number (min 8 digits)."); return false; }
    if (!vAddr(address)) { alert("Please enter a valid delivery address."); return false; }
    if (!dateStr)        { alert("Please select a delivery date."); return false; }
    if (!timeStr)        { alert("Please select a delivery time slot."); return false; }
    if (!plan)           { alert("Please select a plan (Subscribe & Save or One-Time)."); return false; }
    if (plan === "subscribe" && !freq) {
      alert("Please choose Weekly or Fortnightly for your subscription."); return false;
    }*/

    // Normalize to theme’s expected values
    const orderType =
      plan === "subscribe"
        ? (freq === "weekly" ? "WeeklySubscription" : "FortnightlySubscription")
        : "OneTimePurchase";

    // Update theme dropdown so existing listeners react
    const frequencySelect = document.getElementById("order-frequency");
    if (frequencySelect) {
      frequencySelect.value = orderType;
      frequencySelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Helpers to parse the UI’s date/time formats into what createFormData expects
    const parseDeliveryDate = (label) => {
      const m = /\(([^)]+)\)$/.exec(String(label));
      return m ? m[1] : String(label || "");
    };
    const parseTimeSlot = (slot) => {
      const parts = String(slot).split(/–|-/).map(s => s.trim());
      const pad = s => {
        const [h,m="00"] = s.split(":");
        return `${String(h).padStart(2,"0")}:${m}`;
      };
      return parts.length === 2 ? [pad(parts[0]), pad(parts[1])] : ["",""];
    };

    const deliveryDate = parseDeliveryDate(dateStr);
    const [deliveryStart, deliveryEnd] = parseTimeSlot(timeStr);

    // Persist info for LocalCart pipeline
    localStorage.setItem("cartAttributes", JSON.stringify({ orderType: { type: orderType } }));
    localStorage.setItem("deliveryInfo", JSON.stringify({
      deliveryDate,
      deliveryStart,
      deliveryEnd,
      packingDate: ""
    }));

    // Best-effort AU postcode extraction for validatedAddress()
    const postcodeMatch = address.match(/\b(\d{4})\b(?!.*\b\d{4}\b)/);
    localStorage.setItem("widgetAddress", JSON.stringify({
      address_line_combined: address,
      locality_name: "",
      state_territory: "",
      postcode: postcodeMatch ? postcodeMatch[1] : ""
    }));

    // Keep window.state in sync (optional)
    window.state = Object.assign({}, window.state, {
    phone, address, date: dateStr, time: timeStr, plan, freq
    });

    localCart.updateCartInfoFromLocal(".cart-item-loop");
    
  };